import React from 'react';

const Title = ({ children }) => (
  <h1 className='text-4xl md:text-6xl text-center mt-10 md:font-normal font-bold'>{children}</h1>
);

export default Title;
